/* This file is autogenerated, see readme.md for instructions */
import EmailSvgIcon from '@bloomreach/banana-theme/icons/email.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EmailIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EmailSvgIcon />
    </Icon>
  );
});

EmailIcon.displayName = 'EmailIcon';

export default EmailIcon;
